import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiArrowLeft, FiDollarSign } from "react-icons/fi";
import { getHostels, getPendingHostelFees } from "../../services/hostelService";
import { academicYearService } from "../../services/yearService";

export default function PendingHostelFees() {
    const navigate = useNavigate();

    const [academicYears, setAcademicYears] = useState([]);
    const [academicYear, setAcademicYear] = useState("");
    const [hostels, setHostels] = useState([]);
    const [hostel, setHostel] = useState("");
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([academicYearService.getAll(), getHostels()])
            .then(([ayRes, hRes]) => {
                const years = ayRes.data || [];
                setAcademicYears(years);
                setHostels(hRes.data || []);
                const active = years.find((y) => y.isActive) || years[0];
                if (active) setAcademicYear(active._id);
            })
            .catch(() => toast.error("Failed to load hostels/academic years"));
    }, []);

    useEffect(() => {
        if (!academicYear) return;
        setLoading(true);
        const params = { academicYear };
        if (hostel) params.hostel = hostel;
        getPendingHostelFees(params)
            .then((res) => setRows(res.data || []))
            .catch((err) => toast.error(err.response?.data?.message || "Failed to load report"))
            .finally(() => setLoading(false));
    }, [academicYear, hostel]);

    const totalPending = rows.reduce((sum, r) => sum + r.pending, 0);

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title">
                        <FiDollarSign /> Pending Hostel Fees
                    </h1>
                    <p className="page-subtitle">
                        {rows.length} student(s) · ₹{totalPending.toLocaleString("en-IN")} pending
                    </p>
                </div>
                <button className="btn btn-outline" onClick={() => navigate("/hostels")}>
                    <FiArrowLeft /> Back
                </button>
            </div>

            <div className="card">
                <div className="filter-bar">
                    <label>Academic Year:</label>
                    <select
                        className="form-control"
                        style={{ width: 160 }}
                        value={academicYear}
                        onChange={(e) => setAcademicYear(e.target.value)}
                    >
                        {academicYears.map((y) => (
                            <option key={y._id} value={y._id}>
                                {y.label}
                            </option>
                        ))}
                    </select>
                    <label>Hostel:</label>
                    <select
                        className="form-control"
                        style={{ width: 180 }}
                        value={hostel}
                        onChange={(e) => setHostel(e.target.value)}
                    >
                        <option value="">All Hostels</option>
                        {hostels.map((h) => (
                            <option key={h._id} value={h._id}>
                                {h.name}
                            </option>
                        ))}
                    </select>
                </div>

                {loading ? (
                    <div className="loading-center">
                        <div className="spinner" />
                        Loading report...
                    </div>
                ) : rows.length === 0 ? (
                    <div className="empty-state">
                        <p>No pending hostel fees for this selection. 🎉</p>
                    </div>
                ) : (
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Student</th>
                                    <th>Hostel</th>
                                    <th>Room</th>
                                    <th>Total Due</th>
                                    <th>Paid</th>
                                    <th>Pending</th>
                                    <th style={{ textAlign: "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((r, i) => (
                                    <tr key={i}>
                                        <td>
                                            {r.student.fullName}
                                            {r.student.rollNo ? ` (${r.student.rollNo})` : ""}
                                        </td>
                                        <td>{r.hostel.name}</td>
                                        <td>
                                            {r.room.roomNumber} ({r.room.roomType})
                                        </td>
                                        <td>₹{r.totalDue.toLocaleString("en-IN")}</td>
                                        <td>₹{r.totalPaid.toLocaleString("en-IN")}</td>
                                        <td>
                                            <span className="badge badge-full">
                                                ₹{r.pending.toLocaleString("en-IN")}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() =>
                                                    navigate(`/hostel-fee-collect?student=${r.student._id}`)
                                                }
                                            >
                                                Collect
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}